import { consoleChannel } from './console';
import { datadogChannel } from './datadog';
import { LoggerChannel } from './types';

export * from './types';
export { consoleChannel } from './console';
export { datadogChannel } from './datadog';

/**
 * Default channels for the shared application logger, in delivery order.
 * Datadog first (to preserve message ordering with the previous
 * implementation), then the local console.
 */
export const defaultChannels: LoggerChannel[] = [datadogChannel, consoleChannel];
